import React, { useEffect } from "react";

export const FormButton = ({model_name, button_name, onClick})=>{
    useEffect(() => {
    }, []);
    return (
        <div className="ms-2">
            <button
                onClick={onClick}
                className="btn btn-icon btn-radius-8px btn-primary btn-sm"
                >
                <img src="../assets/img/add-circle-icon.png" alt="" width="16" title="" className="me-1"/>
                {button_name}
            </button>
        </div>
    );
}